import { onboarding as en_onboarding } from "../en/onboarding";

/** onboarding — ES slice (29 keys). */
export const onboarding: Record<keyof typeof en_onboarding, string> = {
  onboarding_name_title: "¿Cómo te llamas?",
  onboarding_name_description: "Así es como te verán los demás en Linqx.",
  onboarding_birthdate_title: "¿Cuándo es tu cumpleaños?",
  onboarding_birthdate_description:
    "Tu edad se mostrará en tu perfil. Debes tener al menos 18 años.",
  onboarding_gender_title: "¿Cuál es tu género?",
  onboarding_gender_description:
    "Esto nos ayuda a encontrar mejores matches para ti.",
  onboarding_location_title: "Activa la ubicación",
  onboarding_location_description:
    "Usamos tu ubicación para encontrar posibles matches cerca de ti.",
  onboarding_location_button: "Activar ubicación",
  onboarding_notifications_title: "Mantente al día",
  onboarding_notifications_description:
    "Recibe un aviso cuando tengas un match o un mensaje.",
  onboarding_notifications_button: "Sí, avísame",
  onboarding_interests_title: "Intereses",
  onboarding_interests_description:
    "Cuéntale a todos qué te interesa añadiéndolo a tu perfil.",
  onboarding_photos_title: "Sube tus fotos",
  onboarding_photos_description:
    "Las fotos atractivas aumentarán tus posibilidades de conocer gente nueva.",
  onboarding_photos_description_sub: "Añade al menos 2 fotos para continuar",
  onboarding_photos_main_badge: "Principal",
  onboarding_photos_main_hint:
    "Tu primera foto es la foto principal de tu perfil.",
  onboarding_photos_main_required_title: "Añade una foto principal",
  onboarding_photos_main_required:
    "Añade tu foto principal (la primera casilla) antes de salir de este paso.",
  onboarding_rules_description: "Normas de convivencia",
  onboarding_rules_button: "Empezar",
  onboarding_rule_1_title: "Sé tú mismo.",
  onboarding_rule_1_description:
    "Asegúrate de que tus fotos, tu edad y tu bio reflejen quién eres de verdad.",
  onboarding_rule_2_title: "Cuídate.",
  onboarding_rule_2_description:
    "No compartas tu información personal demasiado pronto.",
  onboarding_rule_3_title: "Con buena onda.",
  onboarding_rule_3_description:
    "Respeta a los demás y trátalos como te gustaría que te traten a ti.",
  onboarding_rule_4_title: "Sé proactivo.",
  onboarding_rule_4_description: "Reporta siempre el mal comportamiento.",
};
